module.exports = __webpack_public_path__ + "db51f6b1bbc9d47f3f473a57e0f5244a.pdf";